module.exports = __webpack_public_path__ + "images/illustrations/illustration-billing-48e6b570eb50c8e13f6696e20fda831a.webp";